export const PersonGlyph = ({ color = "#1D4ED8", size = 26 }) => (
    <svg width={size} height={Math.round(size * 1.54)} viewBox="0 0 26 40" fill="none" aria-hidden="true">
        <circle cx="13" cy="7" r="6" fill={color} />
        <path
            d="M13 15c-5.2 0-8.5 3.6-8.5 8.4V31h3.6v9h3.2v-9h3.4v9h3.2v-9h3.6v-7.6c0-4.8-3.3-8.4-8.5-8.4z"
            fill={color}
        />
    </svg>
);
